import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { HelperService } from 'src/app/service/helper.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class RegionService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService, public helperService: HelperService) {
        super(http, urlProvider);
    }

    searchGetRegionsByPartyId(id: number) {
        this.get(EndPoints.getRegionsByPartyId, false, id).subscribe((x: any) => {
            this.helperService.setUserProfileRegionObject(x['regions']);
        });
    }

    getRegionsByPartyId(partyId: number) {
        return this.get<any>(EndPoints.getRegionsByPartyId, false, partyId);
    }
}
